/* app/js/src/components/graphics/edit/fields/duration.scss */
.cursor-pointer {
  cursor: pointer;
}
* {
  box-sizing: border-box;
}
.container {
  display: flex;
  justify-content: space-between;
}
span {
  margin-top: 9px;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
}
icn-number-input {
  width: 150px;
}
/*# sourceMappingURL=duration.css.map */
